import React from "react";
import { Link } from "react-router-dom";

export default function Home() {
  return (
    <div
      className="relative text-white overflow-hidden flex flex-col mt-0 min-h-screen"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/Background6.png)`,
        backgroundSize: "cover",       // scales and crops to fill container
        backgroundPosition: "center",  // centers the image
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* Top Wave */}
      <Wave />

      {/* Main Section */}
      <section className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-16 flex-grow z-10 px-4 md:px-0 pt-[30vh] md:pt-[25vh] mx-8 pb-10">
        <div className="text-center md:text-left">
          <h1 className="text-3xl md:text-6xl font-bold mb-4">Hi, I'm Mithil!</h1>
          <h2 className="text-2xl md:text-5xl font-extrabold mb-6">
            <span className="text-white">Full Stack </span>
            <span className="text-yellow-300">DEVELOPER</span>
          </h2>
          <p className="max-w-md mb-8 text-gray-300 text-sm md:text-base">
            Passionate about building meaningful software and approaching problems from multiple disciplines.
            Inspired by computer science, machine learning, math, science, economics, and finance.
          </p>
          <div className="space-y-4 md:space-x-4 md:space-y-0 flex flex-col md:flex-row justify-center md:justify-start">
            <Link to="/projects">
              <button className="bg-purple-600 text-white px-6 py-3 md:px-8 md:py-4 rounded-full font-semibold hover:bg-purple-700 transition text-sm md:text-base">
                Projects
              </button>
            </Link>
            <a href={`${process.env.PUBLIC_URL}/Mithil Peeris-CV-Website.pdf`} download>
              <button className="border border-purple-600 px-6 py-3 md:px-8 md:py-4 rounded-full font-semibold text-purple-600 hover:bg-purple-600 hover:text-white transition text-sm md:text-base">
                📄 Download CV
              </button>
            </a>
          </div>
        </div>

        <img
          src={`${process.env.PUBLIC_URL}/Niagra.avif`}
          alt="Mithil Peeris"
          className="w-60 h-60 md:w-80 md:h-80 rounded-full object-cover mt-0 md:mt-0 shadow-lg transition-all duration-500"
        />
      </section>

    </div>
  );
}

function Wave() {
  return (
    <div className="absolute top-0 left-0 w-full overflow-hidden leading-none z-0 mt-16">
      <svg
        className="relative block w-[400%] h-48 animate-wave"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 4800 120"
        preserveAspectRatio="none"
      >
        <path
          fill="#4B0082"
          d="
            M0,60 
            C 150,120 300,0 450,60 
            C 600,120 750,0 900,60 
            C 1050,120 1200,0 1350,60 
            C 1500,120 1650,0 1800,60 
            C 1950,120 2100,0 2250,60 
            C 2400,120 2550,0 2700,60 
            C 2850,120 3000,0 3150,60 
            C 3300,120 3450,0 3600,60 
            C 3750,120 3900,0 4050,60 
            C 4200,120 4350,0 4500,60 
            C 4650,120 4800,0 4950,60 
            V0 
            H0 
            Z"
        />
      </svg>
    </div>
  );
}
